import { Component, Input, OnDestroy } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmationModalComponent } from '../../shared/modal-windows/confirmation-modal/confirmation-modal.component';
import { TicketService } from 'src/app/core/services/ticket/ticket.service';

@Component({
    selector: 'app-hide-post-button',
    templateUrl: './hide-post-button.component.html',
    styleUrls: ['./hide-post-button.component.css'],
    imports: [TranslateModule],
})
export class HidePostButtonComponent implements OnDestroy {
    @Input() ticket;

    private unsubscriber = new Subject<void>();

    constructor(
        private ticketService: TicketService,
        private translateService: TranslateService,
        private bsModalService: BsModalService,
    ) {}

    hidePost() {
        const newHiddenStatus = !this.ticket.isHidden;
        this.ticketService
            .hidePost(this.ticket.id, !newHiddenStatus)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(() => {
                this.ticket.isHidden = newHiddenStatus;
            });
    }

    openHidePostModal() {
        const initialState = {
            title: this.translateService.instant('Are you sure you want to hide this post?'),
            confirmText: this.translateService.instant('Hide'),
            declineText: this.translateService.instant('Cancel'),
            confirmCallback: () => {
                return this.hidePost();
            },
        };

        this.bsModalService.show(ConfirmationModalComponent, {
            initialState,
        });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
